import { Crop } from 'utilities/imageCropper';

export const getCropSettings = (): Crop => ({
  unit: '%',
  x: 25,
  y: 25,
  width: 50,
  height: 50
});

export const ALLOWED_FILES_DESCRIPTION = 'PDF, JPEG, JPG and PNG file types are allowed.';

export const ALLOWED_FILE_MAX_SIZE = 'The maximum file size is 5 MB.';

export const ALLOWED_PHOTO_FILES_DESCRIPTION = 'JPEG, JPG and PNG file types are allowed.';

export const ALLOWED_PHOTO_MAX_SIZE = 'The maximum file size is 2 MB.';
